import { loadProfile, loadProfiles } from 'profiles/action-creators';

export function loadAppData() {
  return (dispatch) => {
    dispatch(loadProfile());
    dispatch(loadProfiles());
  };
}
